import { getDeviceAndUserStore, getRulesStore } from '../storage/stores';
import { DeviceRulesResponse } from '../types/api';
import { getApi } from '.';
import { RulesStore } from '../types/store';

export const fetchRules = async (): Promise<RulesStore> => {
  const deviceAndUser = getDeviceAndUserStore().get();
  if (!deviceAndUser) {
    throw new Error('Device and user store not initialized');
  }

  const currentTimestamp = getRulesStore().get()?.timestamp;
  const headers = currentTimestamp
    ? { 'DEVICE-POLICY-TIMESTAMP': String(currentTimestamp) }
    : undefined;

  const { data }: DeviceRulesResponse = await getApi().deviceRules.get(
    {
      deviceUId: deviceAndUser.device,
    },
    undefined, // query params
    headers
  );

  const ruleId = data.users[deviceAndUser.user]?.rules;
  if (!ruleId || !data.rules[ruleId]) {
    throw new Error('Invalid rules data');
  }

  const { timestamp, timezone } = data;
  const {
    time_restrictions: timeRestrictions,
    web,
    safe_networks_rules: safeNetworks,
  } = data.rules[ruleId];
  const {
    categories,
    is_allow_unknown_sites: allowUnknownSites,
    is_category_list: isCategoryList,
    is_safe_search: isSafeSearch,
    domains: domainRules,
  } = web;
  const safeNetworksRules = {
    delegateProtectionInSafeNetwork:
      safeNetworks.disable_protection_in_safe_network,
  };

  return {
    timestamp,
    timezone,
    timeRestrictions,
    categories,
    allowUnknownSites,
    isCategoryList,
    isSafeSearch,
    domainRules,
    safeNetworksRules,
  };
};
